import { TextStyle } from '@shopify/polaris';
import React, { useContext, useState } from 'react';
import SchedulingContext from '../../Contexts/SchedulingContext';
import {
  AccountClient,
  GET_CALENDAR_SLA_DETAILS,
  GET_SLA_TICKETS,
  TicketClient,
  useQuery
} from '@nile/graphql/src';
import { getDayDetails } from '../../helpers';
import { Avatar, Badge } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import Tippy from '@tippyjs/react';
import SLATicketDetails from './SLATIcketDetails';
import { isEmpty } from 'lodash';
import dayjs from 'dayjs';

const SLAComponent = (props) => {
  return (
    <div className="flex g10 actr mt-10">
      <div className="flex g5 actr">
        <div>
          <TextStyle variation="subdued">{props?.dueCount}</TextStyle>
        </div>
        <div className="fsize12 uppercase">
          <TextStyle variation="subdued">
            <FormattedMessage id="scheduling.header.sla.due" />
          </TextStyle>
        </div>
      </div>

      <div className="flex g5 actr">
        <div>
          <TextStyle weight="Medium" variation="negative">
            {props?.overDueCount}
          </TextStyle>
        </div>
        <div className="fsize12 uppercase">
          <TextStyle variation="negative">
            <FormattedMessage id="scheduling.header.sla.overdue" />
          </TextStyle>
        </div>
      </div>
    </div>
  );
};

const ResourceHeader = (props) => {
  const schedulingContext = useContext(SchedulingContext);
  const technicianIds = schedulingContext?.selectedDispatcherTechnicians.map(
    (el) => el?.userId
  );
  const [overDueTickets, setOverDueTickets] = useState([]);
  const [dueTickets, setDueTickets] = useState([]);

  const popupParentName = 'slaDetailsPopUp';

  const [overDueCount, setOverDueCount] = useState('0');
  const [dueCount, setDueCount] = useState('0');

  const dayDetails = getDayDetails(schedulingContext?.selectedDate);

  const { startTime, endTime } = dayDetails;

  const { loading: listLoading, data: listData } = useQuery(GET_SLA_TICKETS, {
    client: TicketClient,
    fetchPolicy: 'network-only',
    variables: {
      listInfo: {
        page: 1,
        pageSize: 100,
        sort: [
          {
            attribute: 'resolutionDueTime',
            order: 'ASC'
          }
        ],
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'ticketId',
                  operator: 'isNotEmpty',
                  value: ''
                }
              ]
            },
            {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: endTime,
                      operator: 'before',
                      operatorValue: null,
                      attribute: 'resolutionDueTime'
                    }
                  ]
                },
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: '',
                      operator: 'isEmpty',
                      operatorValue: null,
                      attribute: 'resolutionTime'
                    }
                  ]
                },
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: props?.resource?.userId,
                      operator: 'is',
                      operatorValue: null,
                      attribute: 'technician.userId'
                    }
                  ]
                }
              ]
            }
          ]
        },
        view: {
          id: '1'
        }
      }
    },
    onCompleted(res) {
      const overDueTicketData = [];
      const dueTicketData = [];
      res?.getTicketList?.tickets.forEach((ticket) => {
        if (ticket?.resolutionViolated) {
          overDueTicketData.push(ticket);
        }

        if (!ticket?.resolutionViolated) {
          const isOverDueOnDay = dayjs(ticket?.resolutionDueTime).isBefore(
            dayjs(startTime)
          );
          if (isOverDueOnDay) {
            overDueTicketData.push(ticket);
          } else {
            dueTicketData.push(ticket);
          }
        }
      });
      if (!isEmpty(overDueTicketData)) {
        const overdueTicketCount = overDueTicketData?.length?.toString();
        setOverDueCount(overdueTicketCount);
        setOverDueTickets(overDueTicketData);
      }
      if (!isEmpty(dueTicketData)) {
        const dueTicketCount = dueTicketData?.length?.toString();
        setDueCount(dueTicketCount);
        setDueTickets(dueTicketData);
      }
    }
  });

  const initial = props?.label?.[0];
  const events = props?.resource?.events || [];
  let eventCount = 0;
  if (events) {
    events.forEach((event) => {
      const resourceId = props?.resource?.userId;
      if (event?.userId === resourceId) {
        eventCount = eventCount + 1;
      }
    });
  }

  return (
    <div className="fhp flex col jctr actr">
      <div className="flex actr g10 w100 jctr ellipsis">
        <div>
          <Avatar initials={initial} size="extraSmall" />
        </div>
        <div className="f-14 ellipsis">
          <TextStyle>{props?.label}</TextStyle>
        </div>
        <div>
          <Badge>
            <TextStyle>{eventCount}</TextStyle>
          </Badge>
        </div>
      </div>

      {schedulingContext?.showSla && (
        <>
          <Tippy
            content={
              <>
                <SLATicketDetails
                  dueData={dueTickets}
                  overDueData={overDueTickets}
                  loading={listLoading}
                />
              </>
            }
            maxWidth={600}
            interactive
            placement="bottom-start"
            arrow={true}
            theme="light"
            allowHTML
            appendTo={document.body}
            trigger="click"
            zIndex={511}
          >
            <div className={`pointer pointer-events-all ${popupParentName}`}>
              <SLAComponent
                overDueCount={overDueCount}
                dueCount={dueCount}
                user={props?.resource}
              />
            </div>
          </Tippy>
        </>
      )}
    </div>
  );
};

export default ResourceHeader;
